import React from 'react';
import { motion } from 'framer-motion';
/**
 * A clean, subtle visual break between sections.
 * A thin hairline that fades out toward the edges with a small
 * gold diamond accent centered on it.
 */
export function SectionDivider() {
  return <div className="bg-[#0B1014] flex justify-center" role="separator" aria-hidden="true" data-id="element-656">
      <motion.div initial={{
      opacity: 0,
      scaleX: 0.6
    }} whileInView={{
      opacity: 1,
      scaleX: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="relative w-full max-w-5xl mx-auto px-6 flex items-center" data-id="element-657">
        {/* Hairline */}
        <div className="h-px w-full bg-gradient-to-r from-transparent via-white/15 to-transparent" data-id="element-658" />
        {/* Center diamond accent */}
        <div className="absolute left-1/2 -translate-x-1/2 flex items-center justify-center" data-id="element-659">
          <span className="block w-1.5 h-1.5 rotate-45 bg-[#DDA247]" data-id="element-660" />
        </div>
      </motion.div>
    </div>;
}